module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"categories":"Kategorien","search":"Suchen…"},"en":{"categories":"Categories","search":"Search…"}}')
  delete Component.options._Ctor
}
